import { render, staticRenderFns } from "./authenticAtionPending.vue?vue&type=template&id=a540aa32&scoped=true"
import script from "./authenticAtionPending.vue?vue&type=script&lang=js"
export * from "./authenticAtionPending.vue?vue&type=script&lang=js"
import style0 from "./authenticAtionPending.vue?vue&type=style&index=0&id=a540aa32&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a540aa32",
  null
  
)

export default component.exports